import React, { useEffect, useState, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { MyBillStatusCssClasses } from "../MyBillsUIHelpers";
import * as actions from "../../../_redux/myBills/myBillsActions";
import { useMyBillsUIContext } from "../MyBillsUIContext";

const selectedMyBills = (entities, ids) => {
  const _myBills = [];
  ids.forEach((id) => {
    const myBill = entities.find((el) => el.id === id);
    if (myBill) {
      _myBills.push(myBill);
    }
  });
  return _myBills;
};

export function MyBillsUpdateStatusDialog({ show, onHide }) {
  // MyBills UI Context
  const myBillsUIContext = useMyBillsUIContext();
  const myBillsUIProps = useMemo(() => {
    return {
      ids: myBillsUIContext.ids,
      setIds: myBillsUIContext.setIds,
      queryParams: myBillsUIContext.queryParams,
    };
  }, [myBillsUIContext]);

  // MyBills Redux state
  const { myBills, isLoading } = useSelector(
    (state) => ({
      myBills: selectedMyBills(state.myBills.entities, myBillsUIProps.ids),
      isLoading: state.myBills.actionsLoading,
    }),
    shallowEqual
  );

  // if there weren't selected myBills we should close modal
  useEffect(() => {
    if (myBillsUIProps.ids || myBillsUIProps.ids.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myBillsUIProps.ids]);

  const [status, setStatus] = useState(0);

  const dispatch = useDispatch();
  const updateStatus = () => {
    // server request for updateing myBill by ids
    dispatch(actions.updateMyBillsStatus(myBillsUIProps.ids, status)).then(
      () => {
        // refresh list after deletion
        // dispatch(actions.fetchMyBills(myBillsUIProps.queryParams)).then(
        //   () => {
        //     // clear selections list
        //     myBillsUIProps.setIds([]);
        //     // closing delete modal
        //     onHide();
        //   }
        // );
      }
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Status has been updated for selected myBills
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="overlay overlay-block cursor-default">
        {isLoading && (
          <div className="overlay-layer bg-transparent">
            <div className="spinner spinner-lg spinner-warning" />
          </div>
        )}
        <div className="list-timeline list-timeline-skin-light padding-30">
          <div className="list-timeline-items">
            {myBills.map((myBill) => (
              <div className="list-timeline-item mb-3" key={myBill.id}>
                <span className="list-timeline-text">
                  <span
                    className={`label label-lg label-light-${
                      MyBillStatusCssClasses[myBill.status]
                    } label-inline`}
                    style={{ width: "60px" }}
                  >
                    ID: {myBill.id}
                  </span>{" "}
                  <span className="ml-5">
                    {myBill.manufacture}, {myBill.model}
                  </span>
                </span>
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="form">
        <div className="form-group">
          <select
            className={`form-control ${MyBillStatusCssClasses[status]}`}
            value={status}
            onChange={(e) => setStatus(+e.target.value)}
          >
            <option value="0">Selling</option>
            <option value="1">Sold</option>
          </select>
        </div>
        <div className="form-group">
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={updateStatus}
            className="btn btn-primary btn-elevate"
          >
            Update Status
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
